import { ReactNode } from 'react';

import { Box } from '@mui/material';

export const DrawerBody = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      p: 3
    }}
  >
    {children}
  </Box>
);
